<script setup lang="ts">
import { onBeforeUnmount, onMounted } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import AdminShell from './layouts/AdminShell.vue'
import LoginPage from './pages/LoginPage.vue'
import { adminQueryClient } from './queryClient'
import { useSessionStore } from './stores/session'
import { markAdminAnonymous, safeReturnPath } from './router'

const route = useRoute()
const router = useRouter()
const session = useSessionStore()

function redirectToLogin() {
  markAdminAnonymous()
  session.clearSensitiveState()
  adminQueryClient.clear()
  if (route.name === 'admin-login') return
  const returnTo = safeReturnPath(`${window.location.pathname}${window.location.search}${window.location.hash}`)
  void router.replace({ name: 'admin-login', query: { return_to: returnTo } })
}

onMounted(() => window.addEventListener('bondpet-admin-auth-required', redirectToLogin))
onBeforeUnmount(() => window.removeEventListener('bondpet-admin-auth-required', redirectToLogin))
</script>

<template>
  <a class="skip-link" href="#main-content">跳到主内容</a>
  <LoginPage v-if="route.name === 'admin-login'" />
  <AdminShell v-else-if="route.name !== undefined" />
</template>
